import React from 'react'
import SalesGoalContainer from '../../containers/salesgoalmng/SalesGoalContainer'

const SaleGoalViewPage = () => {
  return <SalesGoalContainer />
}

export default SaleGoalViewPage